/**
 * Returns an empty object in case of `null` or `undefined` value,
 * otherwise returns the original object
 * @param  {Object} input
 * @returns {Object}
 */
export default function(input) {
    if(input === null || input === undefined)
        return {}
    return input
}
